/*
 * Clinaray "Buy now": the product page button goes straight to checkout.
 * Used by the add-to-cart block when its "buy_now" setting is on (the block marks itself with data-buy-now).
 * The cart is emptied first, so checkout holds exactly the chosen color, once. The add goes through the
 * cart API, so Shopify's add-to-cart event still fires for analytics and the Meta pixel.
 * If the cart API fails, a cart permalink (/cart/<variant id>:1) still takes the shopper to checkout.
 */
(() => {
  if (window.clinarayBuyNow) return;
  window.clinarayBuyNow = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /** @param {EventTarget | null} target */
  const buyNowBlock = (target) => (target instanceof Element ? target.closest('[data-buy-now]') : null);

  // Skip the theme's add-to-cart animation; the button's native submit still follows.
  window.addEventListener(
    'click',
    (event) => {
      const block = buyNowBlock(event.target);
      if (block && block.closest('form')) event.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const block = form.querySelector('[data-buy-now]');
      if (!block) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.buyNowBusy === 'true') return;

      const idInput = form.querySelector('input[name="id"]');
      const variantId = Number(idInput && idInput.value);
      if (!variantId) return;

      const button = block.querySelector('button');
      form.dataset.buyNowBusy = 'true';
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }

      const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        const cleared = await fetch(`${root}cart/clear.js`, { method: 'POST', headers: json });
        if (!cleared.ok) throw new Error(`cart/clear ${cleared.status}`);
        const added = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: json,
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        if (!added.ok) throw new Error(`cart/add ${added.status}`);
        window.location.assign(`${root}checkout`);
      } catch (error) {
        console.warn('[buy-now] falling back to a cart permalink:', error);
        window.location.assign(`${root}cart/${variantId}:1`);
      }
    },
    true
  );

  // Coming back from checkout with the browser's back button restores this page from cache:
  // re-enable the button this script disabled.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('form[data-buy-now-busy="true"]').forEach((form) => {
      delete form.dataset.buyNowBusy;
      const button = form.querySelector('[data-buy-now] button[aria-busy="true"]');
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    });
  });
})();
